import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { ArrowRight, UserPlus } from "lucide-react";

export default function CtaBand() {
  return (
    <section data-testid="cta-band" className="container-site pb-4">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-brand-blue text-white px-8 py-16 sm:px-16 text-center">
          <img
            src="https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=1600&q=80"
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-brand-blue/75" aria-hidden="true" />
          <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-brand-aqua/25 blur-3xl" aria-hidden="true" />
          <div className="absolute -bottom-24 -right-24 w-72 h-72 rounded-full bg-white/10 blur-3xl" aria-hidden="true" />
          <h2 className="relative text-3xl sm:text-4xl font-extrabold tracking-tight leading-tight">
            Fai il primo passo oggi.
            <br />
            <span className="text-brand-aqua">È gratuito, è riservato, è un tuo diritto.</span>
          </h2>
          <p className="relative mt-5 text-lg text-blue-100 max-w-2xl mx-auto leading-relaxed">
            Compila il modulo di richiesta assistenza o iscriviti gratuitamente all'associazione:
            ti ricontatteremo noi, con gentilezza e senza giudizio.
          </p>
          <div className="relative mt-9 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/assistenza"
              data-testid="cta-band-assistenza-button"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-brand-blue font-bold text-lg px-8 h-14 transition-transform duration-300 hover:-translate-y-0.5"
            >
              Richiedi assistenza
              <ArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/iscrizione"
              data-testid="cta-band-iscrizione-button"
              className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/70 text-white font-bold text-lg px-8 h-14 transition-colors duration-300 hover:bg-white/10"
            >
              <UserPlus className="w-5 h-5" />
              Iscriviti gratis
            </Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
